export const isDevMode = () => !process?.env.NODE_ENV || process?.env.NODE_ENV === 'development';
